import React from "react";
import { observer } from "mobx-react";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DraftsIcon from "@mui/icons-material/Drafts";
import SendIcon from "@mui/icons-material/Send";
import RootStore from "../stores/RootStore";
import { styled } from "@mui/material";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    sx={{
      paper: {
        border: "1px solid #d3d4d5",
      }
    }}
    {...props}
  />
))({});

const StyledMenuItem = styled(MenuItem)(({ theme }) => {
  return {
    "&:focus": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  }
});


const AppBarMainMenu = observer((props) => {
  const { activeWidgetId, openWidget } = RootStore.uiStore;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        edge="start"
        color="inherit"
        aria-label="open menu"
        onClick={handleClick}
      >
        <MenuIcon />
      </IconButton>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <StyledMenuItem
          onClick={() => openWidget("test")}
          selected={activeWidgetId === "test"}
        >
          <ListItemIcon>
            <SendIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Test" />
        </StyledMenuItem>
        <StyledMenuItem
          onClick={() => openWidget("auth")}
          selected={activeWidgetId === "auth"}
        >
          <ListItemIcon>
            <DraftsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Auth" />
        </StyledMenuItem>
        <StyledMenuItem
          onClick={() => openWidget("grid")}
          selected={activeWidgetId === "grid"}
        >
          <ListItemIcon>
            <SendIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Grid" />
        </StyledMenuItem>
      </StyledMenu>
    </div>
  );
});

export default AppBarMainMenu;
